import { useSelector } from "react-redux";
import { selectSkuCategories } from "../../../../../redux/sku";
import { APP_PATHS } from "../../../../../constants/paths";
import { SKUS_QUERY_STRING } from "../../../../../constants/skus";
import { FOOTER_NAV } from "../../../../../constants/nav";
import NavMenu from "./NavMenu/NavMenu";
import classes from "./Navigation.module.css";

const Navigation = () => {
  const categories = useSelector(selectSkuCategories);

  const categoriesMenu = categories.map((category) => ({
    label: category.name,
    to: `${APP_PATHS.SKUS.url}?${SKUS_QUERY_STRING.CATEGORY_NAME}=${category.name}&${SKUS_QUERY_STRING.CATEGORY_ID}=${category.id}`,
  }));

  return (
    <div className={classes["navigation"]}>
      {categories.length > 0 && (
        <NavMenu
          header="الأقسام"
          menu={categoriesMenu}
          className={classes["navigation__categories-list"]}
        />
      )}
      <NavMenu header="حسابي" menu={FOOTER_NAV.acount} />
      <NavMenu header="عروض" menu={FOOTER_NAV.offers} />
    </div>
  );
};

export default Navigation;
